import { MortgageInterface } from '@app/interfaces/mortgage.interface';
import { IncomeTypeEnum } from '@app/enums/income-type.enum';

export class FillingScore2450 {
    static check(mortgage: MortgageInterface): boolean {
        return !!mortgage._contacts.every(
            (a) =>
                a.incomes.every((inc) => {
                    if (!inc.type) {
                        return false;
                    }
                    if (!inc.location) {
                        return false;
                    }
                    const incType: IncomeTypeEnum = IncomeTypeEnum[inc.type];
                    if (![IncomeTypeEnum.noIncome, IncomeTypeEnum.rentalIncome].includes(incType)) {
                        if (!inc.amount && inc.amount !== 0) {
                            return false;
                        }
                    }
                    if (
                        [
                            IncomeTypeEnum.fixedTermEmployment,
                            IncomeTypeEnum.employmentAgreement,
                            IncomeTypeEnum.actionAgreement,
                        ].includes(incType) &&
                        inc.isSubsequent === undefined
                    ) {
                        return false;
                    }
                    if (
                        [
                            IncomeTypeEnum.fixedTermEmployment,
                            IncomeTypeEnum.indefinitePeriodEmployment,
                            IncomeTypeEnum.employmentAgreement,
                            IncomeTypeEnum.actionAgreement,
                        ].includes(incType) &&
                        (inc.isTrialPeriod === undefined || inc.isNoticePeriod === undefined)
                    ) {
                        return false;
                    }
                    if (
                        [
                            IncomeTypeEnum.fixedTermEmployment,
                            IncomeTypeEnum.indefinitePeriodEmployment,
                            IncomeTypeEnum.employmentAgreement,
                            IncomeTypeEnum.actionAgreement,
                            IncomeTypeEnum.diet,
                            IncomeTypeEnum.selfEmployment,
                        ].includes(incType) &&
                        (!inc.source.name || !inc.source.idNumber)
                    ) {
                        return false;
                    }
                    if ([IncomeTypeEnum.rentalIncome, IncomeTypeEnum.futureRentalRevenue].includes(incType)) {
                        if (!inc.source.idNumber) {
                            return false;
                        }
                    }
                    return true;
                }) &&
                a.expenditures.every((exp) => {
                    if (!exp.source.type) {
                        return false;
                    }
                    if (!exp.source.name) {
                        return false;
                    }
                    return true;
                }) &&
                a.bankAccounts.every((ba) => ba.number)
        );
    }
}
